// https://github.com/zeit/styled-jsx#styling-third-parties--child-components-from-the-parent
export default function resolveScopedStyles(scope) {
  return {
    className: scope.props.className,
    styles: scope.props.children,
  }
}
